import React, { useState, useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import withFirst from "../../../../../pages/details/hoc/withFirst";
import { Products } from "../../../listing/components/list";
import { useSelector } from "react-redux";
import { fetchProductYouLikes, fetchProductOftenWith } from "../../../../../../api";
import { action_fetch_often_with_products } from "../../../../../../store/actions/pages/product";
import { Iconfont } from "../../../../../components/icon/iconfont";
import { useRef } from "react";

const OftenWithItem = props =>{
    const { products, loadHandle, loading, finished } = props;

    useEffect(() =>{
        props?.initLoad();
    },[]);


    return <div style={{ paddingBottom: '15px' }} className={classes.YouLikes}>
        {
            products?.length > 0 && <Products
                className={classes.ProductList}
                products={products}
                sensors={{
                    resourcepage_title: 'product',
                    resource_position: '1',
                    resource_type: '4',
                    resource_content: 'You can match with'
                }}
                column="Often Bought With"
            />
        }

        {
            finished && <div className={classes.Finished}>
                <FormattedMessage id="finished" defaultMessage="Finished" />
            </div>
        }

        {
            loading && !finished && <div className={classes.Loading}>
                <FormattedMessage id="loading" defaultMessage="Loading" />
            </div>
        }

        {
            !loading && !finished && <div className={classes.ViewMore}>
                <button onClick={loadHandle}>
                    <FormattedMessage id="view_more" defaultMessage="View More" />
                    <Iconfont className={classes.ViewMoreIcon}>&#xe692;</Iconfont>
                </button>
            </div>
        }

    </div>
}

const OftenWith = props => {
    const { selectedName, productId } = props;
    let initedRef = useRef(false);
    const LIMIT = 20;
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([]);
    const [skip, setSkip] = useState(0);
    const [finished, setFinished] = useState(false);


    const loadHandle = async () => {
        let limit = skip <= 0 ? 60 : LIMIT;
        setLoading(true)
        const products = await fetchProductOftenWith({ skip: skip, limit: limit, productId: productId })
            .then(response => {
                const productItems = response?.result?.map(p => ({
                    ...p,
                    geekoRequsestId: response.requestId,
                    geekoExperimentId: response.experimentId,
                    layerName: response.layerName,
                    trackingRecords: response.trackingRecords
                }))
                return productItems || [];
            })
            .catch(data => {
                console.error(data)
                return []
            }
        )

        setProducts(preValue => [...preValue, ...products]);
        setSkip((preValue) => preValue += limit);
        setLoading(false)
        setFinished(!!!products || products?.length < 1);
    }

    const initData = async () => {
        if (!initedRef.current) {
            initedRef.current = true
            loadHandle();
        }
    }

    return <React.Fragment>
        {
            selectedName === 'oftenwith' && <OftenWithItem initLoad={initData} loading={loading} products={products} loadHandle={loadHandle} finished={finished} />
        }
    </React.Fragment>
}

const YouLikesItem = withFirst(props =>{
    const { products, loadHandle, loading, finished, innerRef, selectedName } = props;

    return <>
        <div ref={innerRef}></div>
        {
            selectedName === 'youlikes' && <div className={classes.YouLikes}>
                {
                    products?.length > 0 && <Products
                        className={classes.ProductList}
                        products={products}
                        sensors={{
                            resourcepage_title: 'product',
                            resource_position: '1',
                            resource_type: '4',
                            resource_content: 'You may also like'
                        }}
                        column="You May Also Like"
                    />
                }

                {
                    finished && <div className={classes.Finished}>
                        <FormattedMessage id="finished" defaultMessage="Finished" />
                    </div>
                }

                {
                    loading && !finished && <div className={classes.Loading}>
                        <FormattedMessage id="loading" defaultMessage="Loading" />
                    </div>
                }

                {
                    !loading && !finished && <div className={classes.ViewMore}>
                        <button onClick={loadHandle}>
                            <FormattedMessage id="view_more" defaultMessage="View More" />
                            <Iconfont className={classes.ViewMoreIcon}>&#xe692;</Iconfont>
                        </button>
                    </div>
                }
            </div>
        }
    </>
})

const YouLikes = props => {
    const { selectedName, productId } = props;
    let inited = false;
    const LIMIT = 20;
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([]);
    const [skip, setSkip] = useState(0);
    const [finished, setFinished] = useState(false);

    const loadHandle = async () => {
        let limit = skip <= 0 ? 48 : LIMIT;
        setLoading(true)
        const products = await fetchProductYouLikes({ skip: skip, limit: limit, productId: productId })
            .then(response => {
                const productItems = response.result?.map(p => ({
                    ...p,
                    geekoRequsestId: response.requestId,
                    geekoExperimentId: response.experimentId,
                    layerName: response.layerName,
                    trackingRecords: response.trackingRecords
                }))
                return productItems;
            })
            .catch(data => {
                console.error(data)
                return []
            }
            )

        setProducts(preValue => [...preValue, ...products]);
        setSkip((preValue) => preValue += limit);
        setLoading(false)
        setFinished(!!!products || products?.length < 1);
    }

    const initData = async () => {
        if (!inited) {
            inited = true
            if (props?.productId) {
                loadHandle();
            }
        }
    }

    return (
        <YouLikesItem initLoad={initData} loading={loading} products={products} loadHandle={loadHandle} finished={finished} selectedName={selectedName} />
    )
}

const ProductRecommendation = props =>{
    useStyles(classes);
    const { productHooks, innerRef } = props;
    const { selectedName, setSelectedName, selectedProduct } = productHooks;

    // const dispatch = useDispatch();

    // const oftenWithEVent = async (productId) => {
    //     setSelectedName("oftenwith");
    //     // dispatch(action_fetch_often_with_products(productId));
    // }

    return <div className={classes.ProductRecommendation}>
         <div ref={innerRef} id="youLikesNav" />
        <div className={classes.Hd}>
            <span 
                onClick={()=>setSelectedName("youlikes")}
                className={`${classes.recommendItem} ${selectedName === 'youlikes' ? classes.Active : ''}`}
            ><FormattedMessage id="you_may_also_likes" defaultMessage="You May Also Like" /></span>
            {/* {
                isATest && <span 
                    onClick={()=>oftenWithEVent(selectedProduct?.id)}
                    className={`${classes.recommendItem} ${selectedName === 'oftenwith' ? classes.Active : ''}`}
                >
                    <FormattedMessage id="you_can_match_with" defaultMessage="You Can Match With" />
                </span>
            } */}
        </div>

        <YouLikes productId={selectedProduct?.id} selectedName={selectedName} />
        
        {/* {
            isATest && <OftenWith productId={selectedProduct?.id} selectedName={selectedName} />
        } */}
    </div>
}

export default ProductRecommendation;